<template>
  <div class="home_container">
    <!-- <router-view/> -->
    <!-- <dev><a href="http://localhost:8080/#/auth/login?thirdParty=tieta&id=5f8f991ce4b0ad226a82164d">测试铁塔项目入口，非测试人员误乱用</a></dev> -->
    <!-- <keep-alive v-if="$route.meta.keepAlive"> -->
        <!-- <router-view :key="key"> -->
            <!-- 这里是会被缓存的视图组件 -->
        <!-- </router-view> -->
    <!-- </keep-alive> -->
    
    <!-- <router-view v-if="!$route.meta.keepAlive" :key="key"> -->
        <!-- 这里是不被缓存的视图组件 -->
    <!-- </router-view> -->
    <router-view ></router-view>
    <!-- <div class="wrap" id="id_openImage">
        <div class="c-mask"  @click="close"></div>
        <div class="inner">
          <div class="c-image-box">
            <img src="" class="c-image" id="id_image_src">
            <div class="c-btn" @click="close"><i class="el-icon-close c-close"></i></div>
          </div>
        </div>
    </div> -->
  </div>
</template>

<script>
import './utils/filter';
export default {
  name: 'App',
   computed:{
      key(){
        return this.$route.name?this.$route.name+ Date.now():this.$route.path+ Date.now()
      }
  },
  methods:{
    // close() {
    //   var d = document.getElementById('id_openImage');
    //   d.style.display = 'none';
    //   // d.childNodes[2].className += ' c-out-active'
    //   d.className += ' c-out-active'
    // }
  }
}
</script>

<style  lang="scss">
@import './style/common.scss';
@import './style/cover-elementui.scss';
@import './assets/iconfont/iconfont.css';
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1000px;
}
.home_container{
  width:100%;
  height:100%;
  overflow: auto;
}
.wrap {
  // display: none;
  position: fixed;
  overflow: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  animation-name: antFadeIn;
  &.c-out-active {
        animation-name: antZoomOut;
      }
  .c-mask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.65);
    position: fixed;
  }
}
.inner {
      display: block;
      position: absolute;
      top: 100px;
      left: 50%;
      margin-left: -260px;
      animation-duration: 0.3s;
      animation-name: antZoomIn;
      padding-bottom: 30px;
      .c-image-box {
        position: relative;
        width: 520px;
        padding: 20px;
        margin: 0 auto;
        background-color: #fff;
      }
      .c-btn {
        position: absolute;
        top: -13px;
        right: -14px;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
      }
      .c-image {
        width: 100%;
      }
      .c-close {
        color:#000000;
        font-size: 20px;
        &:hover{
          color:#000000;
        }
      }
  }
  @keyframes antFadeIn {
      0% {
          opacity: 0;
      }
      100% {
          opacity: 1;
      }
  }
  @keyframes antZoomIn {
      0% {
          transform: scale(0.2);
          opacity: 0;
      }
      100% {
          transform: scale(1);
          opacity: 1;
      }
  }
   @keyframes antZoomOut {
      0% {
          transform: scale(1);
          opacity: 1;
      }
      100% {
          transform: scale(0.2);
          opacity: 0;
      }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue